import * as Yup from 'yup'
import { date, email, phone, postalCode } from './regexes'

export const salutationRequired = Yup.string().required('forms.errors.salutation')

export const emailOptional = Yup.string().matches(email, 'forms.errors.email')

export const emailRequired = emailOptional.required('forms.errors.email')

export const firstNameRequired = Yup.string().required('forms.errors.firstName')

export const lastNameRequired = Yup.string().required('forms.errors.lastName')

export const dateOptional = Yup.string().matches(date, 'forms.errors.date')

export const dateRequired = dateOptional.required('forms.errors.isRequired')

export const phoneOptional = Yup.string().matches(phone, 'forms.errors.phone')

export const phoneRequired = phoneOptional.required('forms.errors.isRequired')

export const passwordOptional = Yup.string().min(8, 'forms.errors.passwordLength')

export const passwordRequired = passwordOptional.required('forms.errors.passwordRequired')

export const passwordConfirmationRequired = Yup.string()
  .oneOf([Yup.ref('newPassword'), null], 'forms.errors.passwordNoMatch')
  .required()

export const companyName = Yup.string()

export const companyNameRequired = companyName.required('forms.errors.companyName')

export const cityRequired = Yup.string().required('forms.errors.city')

export const streetRequired = Yup.string().required('forms.errors.street')

export const houseNumberRequired = Yup.number()
  .typeError('forms.errors.houseNumberRegex')
  .required('forms.errors.houseNumber')

export const houseNumberSuffix = Yup.string()

export const countryCode = Yup.string()

export const countryRequired = Yup.string().required('forms.errors.country')

export const postalCodeRequired = Yup.string()
  .required('forms.errors.postalCode')
  .matches(postalCode, 'forms.errors.postalCodeInvalid')

export const internationalPostalCodeRequired = Yup.string()
  .required('forms.errors.postalCode')
  .min(4, 'forms.errors.postalCodeInvalid')

export const genderRequired = Yup.string().required('forms.errors.salutation')

export const messageRequired = Yup.string().required('forms.errors.message')

export const botDetection = Yup.string().max(0, 'Bot detected')
